// slices/facultySlice.ts

import { createSlice } from '@reduxjs/toolkit'

// Load faculty name or month from localStorage
const loadFacultyName = () => {
  try {
    const serializedState = localStorage.getItem('facultyData')
    // Parse and return if data exists, else return null
    return serializedState ? JSON.parse(serializedState) : null
  } catch (e) {
    // Fallback in case of JSON parsing error
    return null
  }
}

// Initial Redux state
const initialState = {
  name: loadFacultyName() || '', // Load 'name' from localStorage if available
  month: loadFacultyName() || '', // Same logic used for 'month', though this may override the other field (see note below)
}

// Create the Redux slice
export const facultySlice = createSlice({
  name: 'faculty', // Slice name
  initialState,
  reducers: {
    // Action to set faculty name and store it in localStorage
    setFacultyName: (state, action) => {
      state.name = action.payload
      try {
        localStorage.setItem('facultyData', JSON.stringify(action.payload))
      } catch (e) {
        console.error('Could not save faculty name to localStorage', e)
      }
    },

    // Action to clear faculty name and remove it from localStorage
    clearFacultyName: (state) => {
      state.name = ''
      try {
        localStorage.removeItem('facultyName')
      } catch (e) {
        console.error('Could not remove faculty name from localStorage', e)
      }
    },

    // Action to set selected month and store it in localStorage
    setMonth: (state, action) => {
      state.month = action.payload
      try {
        localStorage.setItem('facultyData', JSON.stringify(action.payload))
      } catch (e) {
        console.error('Could not save faculty name to localStorage', e)
      }
    },
  },
})

// Export actions and reducer
export const { setFacultyName, clearFacultyName, setMonth } = facultySlice.actions
export default facultySlice.reducer
